import React from 'react';

import { Translation } from '../../common';

const HEADER_KEY = 'TROY_ON_BEHALF';

export default ({ html, logo, logoClassName, contentClassName }) =>
  html ? (
    <div
      className={contentClassName}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  ) : logo ? (
    <>
      <Translation className={contentClassName}>{HEADER_KEY}</Translation>
      <img className={logoClassName} src={logo} alt="client-logo" />
    </>
  ) : null;
